import { LsnaptienService } from 'src/services/lsnaptien.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const LSNAPTIEN_NEW_CARE_SUCCESS = 'LSNAPTIEN:NEW_CARE_SUCCESS'
export const LSNAPTIEN_LIST_SUCCESS = 'LSNAPTIEN:FIND_ALL_SUCCESS'
export const LSNAPTIEN_LIST_FAILD = 'LSNAPTIEN:FIND_ALL_FAILD'
export const LSNAPTIEN_COUNT_ASSIGN_SUCCESS = 'LSNAPTIEN:COUNT_ASSIGN_SUCCESS'
export const LSNAPTIEN_COUNT_ASSIGN_FAILD = 'LSNAPTIEN:COUNT_ASSIGN_FAILD'

export const LSNAPTIEN_CREATE_SUCCESS = 'LSNAPTIEN:CREATE_SUCCESS'
export const LSNAPTIEN_CREATE_FAILD = 'LSNAPTIEN:CREATE_FAILD'

export const LSNAPTIEN_IMPORT_SUCCESS = 'LSNAPTIEN:IMPORT_SUCCESS'
export const LSNAPTIEN_SAVE_SUCCESS = 'LSNAPTIEN:SAVE_SUCCESS'
export const LSNAPTIEN_SAVE_FAILD = 'LSNAPTIEN:SAVE_SUCCESS'

export const LSNAPTIEN_DEL_SUCCESS = 'LSNAPTIEN:DEL_SUCCESS'
export const LSNAPTIEN_DEL_FAILD = 'LSNAPTIEN:DEL_FAILD'

export const LSNAPTIEN_ONE_SUCCESS = 'LSNAPTIEN:FIND_ONE_SUCCESS'
export const LSNAPTIEN_ONE_FAILD = 'LSNAPTIEN:FIND_ONE_FAILD'

export const LSNAPTIEN_HISTORY_LIST_SUCCESS = 'LSNAPTIEN:HISTORY_FIND_ALL_SUCCESS'
export const LSNAPTIEN_HISTORY_LIST_FAILD = 'LSNAPTIEN:HISTORY_FIND_ALL_FAILD'

export const LSNAPTIEN_UPDATE_FILTER = 'LSNAPTIEN:UPDATE_FILTER'

export const LsnaptienAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,
}

function updateFilter(payload) {
    return { type: LSNAPTIEN_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            LsnaptienService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(LsnaptienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: LSNAPTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            LsnaptienService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(LsnaptienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: LSNAPTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        LsnaptienService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { lsnaptien } = getState()
        dispatch(AppAction.appLoading(true));
        LsnaptienService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...lsnaptien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { lsnaptien } = getState();
        const page = lsnaptien && typeof lsnaptien.filter !== 'undefined' && lsnaptien.filter && typeof lsnaptien.filter.page !== 'undefined' ? lsnaptien.filter.page : 0;
        const limit = lsnaptien && typeof lsnaptien.filter !== 'undefined' && lsnaptien.filter && typeof lsnaptien.filter.limit !== 'undefined' ? lsnaptien.filter.limit : 10;
        LsnaptienService.findAll(page, limit, lsnaptien.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count,
                }));
            } else {
                const oldItems = lsnaptien.items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count,
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: LSNAPTIEN_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            LsnaptienService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(LsnaptienAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: LSNAPTIEN_SAVE_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            LsnaptienService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(LsnaptienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: LSNAPTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        LsnaptienService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(LsnaptienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        LsnaptienService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(LsnaptienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_DEL_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        LsnaptienService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_ONE_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        LsnaptienService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(LsnaptienAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { lsnaptien } = getState()
        dispatch(AppAction.appLoading(true));
        LsnaptienService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...lsnaptien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: LSNAPTIEN_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: LSNAPTIEN_HISTORY_LIST_FAILD, error } }
}